import { defineAction } from '~/prix'
import actionJson from './privateFileDownload.action.json' with { type: 'json' }
import { z } from 'zod'
import { privateFileObject } from '../privateFileObject'

const privateFileDownloadDefinition = defineAction({
  ...actionJson,
  input: z.object({
    fileId: z.string().uuid(),
    disposition: z.enum(['inline', 'attachment']).default('attachment'),
  }),
  output: z.object({
    downloadUrl: z.string().url(),
    privateFile: privateFileObject,
  }),
})

export default privateFileDownloadDefinition
